export enum AREA_TYPE {
  CADASTERS = 'cadasters',
  CITIES = 'obce',
  ORPS = 'orp',
  REGIONS = 'kraje',
}

export const PREDEFINED_AREAS_SET_FEATURES = 'PREDEFINED_AREAS_SET_FEATURES';

export enum UNMANAGED_AREA_LAYERS {
  CUSTOM_AREAS = 'custom-areas',
  PREDEFINED_AREAS = 'predefined-areas',
}
